import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/icons/Coin.png'
import _imports_1 from '@/assets/images/static/Bag.png'


const _hoisted_1 = { class: "global-wrapper invoice-banner-wrapper" }
const _hoisted_2 = { class: "global-container invoice-banner-container" }
const _hoisted_3 = { class: "invoice-banner" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "invoice-banner__coin",
  src: _imports_0
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "bag",
  src: _imports_1
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("img", {
          class: "invoice-banner__title",
          src: _ctx.imgUrl
        }, null, 8, ["src"]),
        _hoisted_5
      ])
    ])
  ]))
}